import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { SessionService } from './ssession.service';

export const notAllowedMsg = [
  'JWT Token not found',
  'Nieprawidłowa Nazwa użytkownika lub Hasło. Proszę wpisać prawidłową nazwę użytkownika lub hasło.'
];

export function prepareRequest(v: any) {
  if (!!v) {
    const keys = Object.keys(v);
    const body = { ...v };
    keys.forEach(key => {
      switch (true) {
        case body[key] === undefined: {
          body[key] = null;
          break;
        }
        case v[key] === '': {
          body[key] = null;
          break;
        }
      }
    });
    return keys.length ? body : v;
  } else {
    return v;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor {

  constructor(
  ) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (SessionService.Authed() && request.url.includes(environment.apiBasePath)) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + SessionService.GetAccessToken()),
        body: request.body
      });
    }

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((response: any) => {

        // if (response instanceof HttpErrorResponse && (response.status >= 400 && response.status < 500)) {
        //   const violations: string [] = response.error?.violations?.filter((v: any) => !!v?.messages)?.filter((v: string) => !notAllowedMsg.includes(v)) || [];
        //   violations.forEach((v: string) => this.notifierService.notify('error', v));
        //
        //   if (response.error?.message && !notAllowedMsg.includes(response.error?.message)) {
        //     this.notifierService.notify('error', response.error.message);
        //   } else if (response.error?.detail && !notAllowedMsg.includes(response.error?.detail)) {
        //     this.notifierService.notify('error', response.error.detail);
        //   }
        // }
        //
        // if (response instanceof HttpErrorResponse && response.status === 500) {
        //   this.notifierService.notify('error', response.error?.detail || 'Błąd systemu. Skontaktuj się z administratorem.');
        // }

        return throwError(response);
      })
    );
  }
}
